var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(_vm.branding.logostyle),attrs:{"src":_vm.branding.logo,"alt":_vm.branding.name,"id":"site-logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }